import { QueryHookOptions } from '@apollo/client';

import {
  RetailerNetworkScanDataTobaccoSiteSubmissionFilter,
  RetailerNetworkScanDataTobaccoSiteSubmissionsFragment,
  RetailerNetworkScanDataTobaccoSiteSubmissionsQuery,
  RetailerNetworkScanDataTobaccoSiteSubmissionsQueryVariables,
  useRetailerNetworkScanDataTobaccoSiteSubmissionsQuery,
} from '@occc/graphql';
import { PaginationInfo, usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';

type UseRetailerNetworkScanDataTobaccoSiteSubmissionsProps = {
  pageSize?: number;
  baseOptions?: QueryHookOptions<
    RetailerNetworkScanDataTobaccoSiteSubmissionsQuery,
    RetailerNetworkScanDataTobaccoSiteSubmissionsQueryVariables
  >;
  filter: RetailerNetworkScanDataTobaccoSiteSubmissionFilter;
  paginationInfo?: PaginationInfo;
};

const transformDataToRetailerNetworkScanDataTobaccoSiteSubmissionsArray = (
  data: RetailerNetworkScanDataTobaccoSiteSubmissionsQuery,
): RetailerNetworkScanDataTobaccoSiteSubmissionsFragment[] => {
  const { edges } = data.retailerNetworkScanDataTobaccoSiteSubmissions;
  return edges?.map((item) => item.node) || [];
};

export const useRetailerNetworkScanDataTobaccoSiteSubmissions = ({
  filter,
  pageSize,
  baseOptions,
  paginationInfo,
}: UseRetailerNetworkScanDataTobaccoSiteSubmissionsProps) => {
  const response = usePaginatedQuery(
    useRetailerNetworkScanDataTobaccoSiteSubmissionsQuery,
    'retailerNetworkScanDataTobaccoSiteSubmissions.pageInfo',
    pageSize,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      ...baseOptions,
      variables: {
        ...baseOptions?.variables,
        filter,
      },
    },
    paginationInfo,
  );

  return {
    ...response,
    data: response.data
      ? transformDataToRetailerNetworkScanDataTobaccoSiteSubmissionsArray(response.data)
      : response.data,
  };
};
